import './assets/main.css'
import '@fortawesome/fontawesome-free/css/all.css'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faEye, faEdit, faTrash, faPlus, faProjectDiagram, faInbox } from '@fortawesome/free-solid-svg-icons'
import VueApexCharts from "vue3-apexcharts";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import gfilters from './utils/global_filters';
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

const app = createApp(App)

library.add(faEye, faEdit, faTrash, faPlus, faProjectDiagram, faInbox, faGlobe, faInstagram, faFacebook)

app.use(createPinia())
app.use(router)
app.component('apex-chart', VueApexCharts)
app.use(Toast);
app.config.globalProperties.$gfilter = gfilters;
app.mount('#app')
